import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { ServersFilterAction } from '../serversFilter.action';
import { ServerParam } from '../_helpers/serverSearchParam';

export const clearSelectServerEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(ServersFilterAction.clearSelect),
  map(() => {
    return RouterAction.removeParam(ServerParam.name);
  }),
);
